import create from "zustand";
import { immerMiddleware } from "./immer-helper";

interface IPipelineStore {
    sessionToken?: string;
    setSessionToken: (sessionToken: string) => void;
}

const useUserStore = create<IPipelineStore>(
    immerMiddleware((set, get) => ({
        sessionToken: "",
        setSessionToken: (sessionToken) => {
            set((state) => {
                state.sessionToken = sessionToken;
            });
        },
    }))
);

export default useUserStore;
